import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const Load = name => () => import(`./views/${name}`);
const RoutesSchema = [
  {
    path: "/user-accounts",
    folderName: "Accounts",
    routes: ["create"],
    wildcardComponent: "view"
  },
  {
    path: "/company",
    folderName: "Company",
    routes: ["create"],
    wildcardComponent: "view"
  }
];

const Routes = [];

RoutesSchema.forEach(({ path, folderName, routes, ...args }) => {
  Routes.push({
    path,
    name: folderName,
    component: Load(`${folderName}/index`)
  });

  routes.forEach(route => {
    Routes.push({
      path: `${path}/${route}`,
      name: `${folderName + route}`,
      component: Load(`${folderName}/${route}`)
    });
  });

  if (args.wildcardComponent) {
    Routes.push({
      path: `${path}/:id`,
      name: `${folderName + args.wildcardComponent}`,
      component: Load(`${folderName}/${args.wildcardComponent}`)
    });
  }
});

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Dashboard",
      component: Load("Dashboard")
    },
    {
      path: "/create",
      name: "Create",
      component: Load("Create")
    },
    ...Routes,
    {
      path: "/settings",
      name: "User Settings",
      component: Load("User")
    },
    // Evoting Entity
    {
      path: "/evoting/entity",
      name: "EvotingEntity",
      component: () => import("./views/Entity/index.vue")
    },
    {
      path: "/evoting/entity/create",
      name: "EvotingEntityCreate",
      component: () => import("./views/Entity/create.vue")
    },
    {
      path: "/evoting/entity/:id",
      name: "EvotingEntityWildCard",
      component: () => import("./views/Entity/view.vue")
    },
    // Evoting Event
    {
      path: "/evoting/event",
      name: "EvotingEvent",
      component: () => import("./views/Event/index.vue")
    },
    {
      path: "/evoting/event/create",
      name: "EvotingEventCreate",
      component: () => import("./views/Event/create.vue")
    },
    {
      path: "/evoting/event/:id",
      name: "EvotingEventWildCard",
      component: () => import("./views/Event/view.vue")
    },
    // Authentication
    {
      path: "/authentication/create",
      name: "CreateAuth",
      component: () => import("./views/Authentication/create.vue")
    },
    {
      path: "/authentication/resource",
      name: "Resources",
      component: () => import("./views/Authentication/resource.vue")
    },
    {
      path: "/authentication/action",
      name: "Actions",
      component: () => import("./views/Authentication/action.vue")
    },
    {
      path: "/authentication/role",
      name: "Roles",
      component: () => import("./views/Authentication/role.vue")
    },
    {
      path: "/authentication/action/:id",
      name: "ActionsWildcard",
      component: () => import("./views/Authentication/view/action.vue")
    },
    {
      path: "/authentication/role/:id",
      name: "RolesWildcard",
      component: () => import("./views/Authentication/view/role.vue")
    },
    {
      path: "/authentication/resource/:id",
      name: "ResourcesWildcard",
      component: () => import("./views/Authentication/view/resource.vue")
    }
  ]
});
